var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center"},[_c('btn-link',{on:{"click":_vm.handleRemoveResponsible}},[_vm._v("Remover")]),_c('btn-link',{staticClass:"ml-3",on:{"click":_vm.handleChangeData}},[_vm._v("Alterar Dados")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }